import {
  IDispenseRequest,
  IDispenseRequestFromHandover,
  IRepairOrderRequest,
  IRepairPart,
} from "../@types/dispense";
import axios from "../utils/axios";

export class DispenseService {
  getAllDispenses(params?: { page?: number; limit?: number }) {
    return axios.get("/dispense", { params });
  }
  exportDispenseRecords(query?: string) {
    return axios.get(`/dispense/export/csv${query ? `?${query}` : ""}`, {
      responseType: "text",
    });
  }
  getDispense(dispenseId: number) {
    return axios.get(`/dispense/${dispenseId}`);
  }
  getDispenseByPatientId(patientId: number | string) {
    return axios.get(`/dispense/patient/${patientId}`);
  }
  createDispense(data: IDispenseRequest) {
    return axios.post("/dispense", data);
  }
  updateDispense(id: number, data: IDispenseRequest) {
    return axios.patch(`/dispense/${id}`, data);
  }
  deleteDispense(id: number) {
    return axios.delete(`/dispense/${id}`);
  }
  createDispenseFromHandover(
    patientId: string | undefined,
    data: IDispenseRequestFromHandover
  ) {
    return axios.post(`/dispense/${patientId}`, data);
  }
  createRepairOrder(data: IRepairOrderRequest) {
    return axios.post("/dispense/repair", data);
  }
  getRepairParts() {
    return axios.get("/dispense/repair/parts");
  }
  createRepairPart(data: Omit<IRepairPart, "id">) {
    return axios.post("/dispense/repair/parts", data);
  }
  updateRepairPart(id: string, data: Partial<IRepairPart>) {
    return axios.patch(`/dispense/repair/parts/${id}`, data);
  }
  deleteRepairPart(id: string) {
    return axios.delete(`/dispense/repair/parts/${id}`);
  }
  getAllRepairOrders() {
    return axios.get("/dispense/repair/orders");
  }
}
